import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getEditorRestrictionsRoot = (state: RootState) => state.editorRestrictions;

const isEditingRestricted = createSelector(getEditorRestrictionsRoot, ({ isChecked, editingRestricted }) => isChecked && editingRestricted);
const quotaShortfall = createSelector(getEditorRestrictionsRoot, ({ quotaShortfall }) => quotaShortfall);

export const EditorRestrictionsSelectors = {
    isEditingRestricted,
    quotaShortfall,
};
